import { render, staticRenderFns } from "./RegieRequestManagement.vue?vue&type=template&id=0458fa5e&"
import script from "./RegieRequestManagement.vue?vue&type=script&lang=js&"
export * from "./RegieRequestManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports